import type { ChartDataItem } from "@/react/components/Analytics/components/types";
import { getColors } from "@/react/components/SettingsApp/AnalyticsV4/hooks/getColor";

// Dummy data for charts
export const dateLabels = [`Oct 1`, `Oct 7`, `Oct 14`, `Oct 21`, `Oct 27`];

// Chart 1: Views and Unique viewers (count-based metrics)
export const viewsData: ChartDataItem[] = dateLabels.map((date, index) => {
  const dataPoints = [
    { views: 45000, unique_viewers: 1200000 },
    { views: 85000, unique_viewers: 1450000 },
    { views: 120000, unique_viewers: 1620000 },
    { views: 95000, unique_viewers: 1580000 },
    { views: 135890, unique_viewers: 1783212 },
  ];

  return {
    id: date,
    label: date,
    ...dataPoints[index],
  };
});

// Chart 2: Average completion rate (percentage-based metric)
export const completionData: ChartDataItem[] = dateLabels.map((date, index) => {
  const dataPoints = [
    { avg_completion: 70 },
    { avg_completion: 22 },
    { avg_completion: 50 },
    { avg_completion: 24 },
    { avg_completion: 100 },
  ];

  return {
    id: date,
    label: date,
    ...dataPoints[index],
  };
});

export const viewsSeriesKeys = ["views", "unique_viewers"];
export const completionSeriesKeys = ["avg_completion"];
export const viewsColors = getColors(2);
export const completionColors = getColors(1);
